import { VUEX_FORM_MUTATION_NAMES } from "@tt-app/constants/form";

const { UPDATE_FORM } = VUEX_FORM_MUTATION_NAMES as { UPDATE_FORM: string };

const formMutations = {
  [UPDATE_FORM]: (state: any, formDetails: any) => {
    const { formName, field, value } = formDetails;

    state[formName][field].value = value;
  }
};

export { formMutations };
